import JSONAPIAdapter from '@ember-data/adapter/json-api';
import { service } from '@ember/service';

import config from 'garaje/config/environment';
import { SERVICE_REQUEST_TIMEOUT_MS } from 'garaje/utils/catch-service-error';

export default class RmsAdapter extends JSONAPIAdapter {
  host = config.rmsHost;
  namespace = 'a/rms';
  useFetch = false;

  @service cookieAuth;
  @service metrics;
  @service session;

  handleResponse(status, _headers, _payload, _requestData) {
    if (status === 401 && this.session.isAuthenticated) {
      this.session.invalidate();
    }
    return super.handleResponse(...arguments);
  }

  ajaxOptions(url, type, options = {}) {
    let hash = super.ajaxOptions(url, type, options);
    hash = this.cookieAuth.decorate(type, hash);
    hash.headers['X-Forwarded-Host'] = config.hostName;
    hash.headers['X-Envoy-Context'] = JSON.stringify(this.metrics.getEnvoyContext());
    // Reads only: timing out a slow write invites a retry of an operation the
    // server may still commit
    if (type === 'GET') {
      hash.timeout = SERVICE_REQUEST_TIMEOUT_MS;
    }

    return hash;
  }

  ajax(url, method, hash = {}) {
    hash.xhrFields = { withCredentials: true };
    if (config.proxyMode && url.includes('app.envoy.christmas')) {
      // Can be removed if rms returns relative paths in JSON API relationships
      url = url.replace('app.envoy.christmas', 'dashboard.envoy.dev');
    }
    return super.ajax(url, method, hash);
  }

  shouldBackgroundReloadAll() {
    return false;
  }

  shouldBackgroundReloadRecord() {
    return false;
  }
}
